import React, { ReactElement } from 'react';
import { Link } from 'react-router-dom';
import cn from 'classnames';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableContainer from '@material-ui/core/TableContainer';
import TableRow from '@material-ui/core/TableRow';
import TableHead from '@material-ui/core/TableHead';
import { Box, Menu, MenuItem } from '@material-ui/core';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import Routes from 'routes';
import { isLastElement } from 'globals/utils';
import defaultLocales from 'globals/locales/default';
import FsDate from 'ui-elements/common-elements/FsDate';
import FsAvatarWithName from 'ui-elements/common-elements/FsAvatarWithName';
import FsIconButton from 'ui-elements/buttons/FsIconButton';
import {
  Cell,
  HeadCell,
  HeadLabel,
  InvitationsNumber,
  ReportsNumber,
  Row,
} from './FsLeaderboardTable.style-elements';

export interface FsLeaderboardTableDataProps {
  id: string | number;
  name: string | ReactElement;
  email: string;
  date: number;
  reports: number;
  invitations: number;
}

export interface FsLeaderboardTableProps {
  rows?: FsLeaderboardTableDataProps[];
  isLongVersion?: boolean;
  headLabels?: string[];
}

const FsLeaderboardTable: React.FC<FsLeaderboardTableProps> = ({
  rows = [],
  headLabels = [],
  isLongVersion = false,
}) => {
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement>();
  const [currentId, setCurrentId] = React.useState<number | string>();
  const open = Boolean(anchorEl);
  const handleIconButtonClick = (
    event: React.MouseEvent<HTMLElement>,
    id: number | string
  ): void => {
    setAnchorEl(event.currentTarget);
    setCurrentId(id);
  };

  const handleClose = (): void => {
    setAnchorEl(undefined);
  };

  return (
    <TableContainer>
      <Table>
        {headLabels.length ? (
          <TableHead>
            <TableRow data-test="table-head-row">
              {headLabels.map((label) => (
                <HeadCell
                  key={label}
                  withIconOnly={isLongVersion && label === ''}
                >
                  <HeadLabel>{label}</HeadLabel>
                </HeadCell>
              ))}
            </TableRow>
          </TableHead>
        ) : null}
        <TableBody>
          {rows.map(({ id, name, email, date, reports, invitations }, idx) => (
            <Row
              key={id}
              className={cn({ isLast: isLastElement(idx, rows?.length) })}
            >
              <Cell component="th">
                <Box marginTop={1}>
                  <FsAvatarWithName subContent={email}>{name}</FsAvatarWithName>
                </Box>
              </Cell>
              <Cell>
                <FsDate date={date} withYear />
              </Cell>
              <Cell>
                <InvitationsNumber>{invitations}</InvitationsNumber>
              </Cell>
              <Cell>
                <ReportsNumber>{reports}</ReportsNumber>
              </Cell>
              <Cell withIconOnly>
                <FsIconButton
                  size="small"
                  onClick={(e) => handleIconButtonClick(e, id)}
                >
                  <MoreVertIcon />
                </FsIconButton>
                <Menu
                  anchorEl={anchorEl}
                  open={open && currentId === id}
                  onClose={handleClose}
                >
                  <MenuItem
                    button
                    selected={false}
                    component={Link}
                    to={Routes.REPORTS}
                  >
                    <span>{defaultLocales.checkReports}</span>
                  </MenuItem>
                  <MenuItem
                    button
                    selected={false}
                    component={Link}
                    to={Routes.INVITATIONS}
                  >
                    <span>{defaultLocales.checkInvitations}</span>
                  </MenuItem>
                </Menu>
              </Cell>
            </Row>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default FsLeaderboardTable;
